import React, { useEffect, useState } from 'react';
import { CloudSlash } from '@phosphor-icons/react';

/**
 * OfflineBanner — slim top strip shown when the browser loses network.
 * Auto-hides when connection returns.
 */
export default function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      className="fixed top-0 inset-x-0 z-[80] bg-amber-500 text-black border-b-2 border-black"
      role="status"
      aria-live="polite"
      data-testid="offline-banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-sm font-bold">
        <CloudSlash size={16} weight="bold" />
        <span>You're offline. Some features won't work until you reconnect.</span>
      </div>
    </div>
  );
}
